var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('help.ISAInsightRoomFallRate_title')))]),_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm.$t('The fall rate is the average period between each fall.'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }